import React, { createContext, useContext, useState, useCallback } from 'react'

const ToastContext = createContext()

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([])

  const showToast = useCallback((message, status = 'green') => {
    const id = Date.now()

    setToasts((prev) => [...prev, { id, message, status }])

    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id))
    }, 5000)
  }, [])

  const getColor = (status) => {
    switch (status) {
      case 'green':
        return 'bg-green-600'
      case 'yellow':
        return 'bg-yellow-500'
      case 'red':
        return 'bg-red-600'
      default:
        return 'bg-gray-700'
    }
  }

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <div className='text-xl fixed bottom-4 right-4 space-y-2 z-50'>
        {toasts.map(({ id, message, status }) => (
          <div
            key={id}
            className={`text-white px-4 py-2 rounded shadow-md animate-fade-in-up ${getColor(
              status
            )}`}
          >
            {message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  )
}

export const useToast = () => useContext(ToastContext)
